import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Heading4 = ({ node }: RichTextContentProps) => {
  return (
    <h4>
      <RichTextContent node={node} />
    </h4>
  );
};

export default Heading4;
